import React from 'react';
import {
  Chat,
  Channel,
  Window,
  LoadingIndicator,
  MessageList,
  WithComponents,
} from 'stream-chat-react';
import 'stream-chat-react/dist/css/v2/index.css';
import { Icon, H4 } from 'design-system-web';
import { useGetStreamChatInit } from './hooks/useGetStreamChatInit';
import { Message, CommentInput } from './components';
import { renderMessagesNewestFirst } from './utils/renderMessagesNewestFirst';

export interface WorkOrderCommentsProps {
  channelId: string;
  chatTitle: string;
  commentBoxPosition?: 'bottom' | 'top';
  showMessagesCountInTitle?: boolean;
  messagingToken: string;
  user: {
    id: string;
    name?: string;
  };
}

const attachmentIcon = () => <Icon name="paperclip" />;

const messageActions = ['edit', 'delete'];

export function WorkOrderComments({
  channelId,
  chatTitle,
  commentBoxPosition = 'bottom',
  showMessagesCountInTitle = false,
  messagingToken,
  user,
}: WorkOrderCommentsProps) {
  const { chatClient, channel, loading, error } = useGetStreamChatInit({
    user,
    channelId,
    tokenOrProvider: messagingToken,
  });

  if (loading) return <LoadingIndicator />;

  if (error) return <div className="">{error}</div>;

  if (!chatClient || !channel) return null;

  const messagesCount = channel.state?.messages?.length || 0;

  return (
    <div className="mt-2 flex flex-col" style={{ height: '100%' }}>
      <Chat client={chatClient} theme="messaging light">
        <Channel
          channel={channel}
          AttachmentSelectorInitiationButtonContents={attachmentIcon}
          Message={Message}
        >
          <WithComponents
            overrides={{
              AutocompleteSuggestionList: () => null,
              UnreadMessagesNotification: () => null,
              UnreadMessagesSeparator: () => null,
            }}
          >
            <Window>
              <div className="flex flex-col" style={{ height: '100%' }}>
                <H4 mb={4} className="flex-shrink-0">
                  {chatTitle}
                  {showMessagesCountInTitle && ` (${messagesCount})`}
                </H4>

                <div className="flex flex-col" style={{ height: '100%' }}>
                  {commentBoxPosition === 'top' && (
                    <>
                      <div className="flex-shrink-0">
                        <CommentInput />
                      </div>
                      <div className="flex-1 overflow-hidden">
                        <MessageList
                          renderMessages={renderMessagesNewestFirst}
                          messageActions={messageActions}
                          hideNewMessageSeparator
                        />
                      </div>
                    </>
                  )}

                  {commentBoxPosition === 'bottom' && (
                    <>
                      <div className="flex-1 overflow-hidden">
                        <MessageList 
                          noGroupByUser
                          messageActions={messageActions} 
                          hideNewMessageSeparator
                        />
                      </div>
                      <div className="flex-shrink-0">
                        <CommentInput />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </Window>
          </WithComponents>
        </Channel>
      </Chat>
    </div>
  );
}